import { loader } from '@monaco-editor/react';
export { loader, useMonaco } from '@monaco-editor/react';
export { DiffEditor } from './DiffEditor.js';
export { MonacoEditor, buildMonacoTheme, monacoBaseOptions } from './MonacoEditor.js';

const monacoEditorVersion = process.env.NEXT_PUBLIC_MONACO_EDITOR_VERSION || "0.34.1";
loader.config({
    paths: {
        vs: `https://cdn.jsdelivr.net/npm/monaco-editor@${monacoEditorVersion}/min/vs`
    }
});
